import { Component, Input, OnInit } from "@angular/core";
declare var jQuery: any;

@Component({
    selector: 'app-carousel-photo',
    templateUrl: './carousel-photo.component.html'
})

export class CarouselPhotoComponent implements OnInit {
    @Input()
    public images = [];
    constructor() {
    }

    ngOnInit() {
    }
    
    ngAfterViewInit() {
        jQuery(document).ready(function () {
            setTimeout(() => {
                jQuery('.carousel').carousel({
                    interval: 4000
                })
            }, 2000)
        });
    }
    
    preventDefault(event, prevent) {
        if (prevent) {
            event.preventDefault();
        } else {
            return;
        }
    }
}
